import React from 'react'

interface Props {
  tribeName: string
}

const TribeHeaderContainer = ({ tribeName }: Props) => {
  return (
    <div className="tribe-org__tribe-header">
      <h2 className="tribe-org__tribe-name">{tribeName}</h2>
    </div>
  )
}

export default TribeHeaderContainer
